import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";
import { printComponent } from "./print";
import CustomTooltip from "./CustomTooltip";

const PrintButton = () => {
  function printLetter() {
    return printComponent("print", "receipt");
  }
  return (
    <CustomTooltip message={"Print"}>
      <Button
        onClick={() => printLetter()}
        type="primary"
        className="btn btn-primary printbtn"
      >
        <FontAwesomeIcon icon={faPrint} />
      </Button>
    </CustomTooltip>
  );
};

export default PrintButton;
